import React, { useState } from 'react';
import './GlobalSearch.scss';
import SiteLoader from 'components/page-loader/page-loader';
import useGlobalSearchController from './useGlobalSearchController';
import clsx from 'clsx';

const GlobalSearch = () => {
  const controller = useGlobalSearchController();
  const [isFocused, setIsFocused] = useState(false);
  const searchValue = controller.inputValue;
  const hidePlaceholder = isFocused || searchValue;
  const placeHolder = 'Search card number or vehicle registration';

  return (
    <div className="global-card-search">
      <div className={clsx('custom-search')}>
        <div className="relative w-full h-full">
          <div
            className={clsx(
              hidePlaceholder && 'opacity-0',
              'absolute flex items-center w-full justify-center h-full pointer-events-none transition-opacity gap-xxs',
              'text-ampol-black'
            )}
          >
            <img src="/icon-search.svg" className="!h-[18px] !invert-0" />
            <p className="text-white">{placeHolder ?? 'Search'}</p>
          </div>

          <div
            className={clsx(
              'absolute p-[12px] flex items-center w-full justify-end h-full pointer-events-none gap-xxs'
            )}
          >
            <img
              src="/icon-search.svg"
              className={clsx(
                'absolute !h-[18px] !invert-0',
                (searchValue || !isFocused) && 'opacity-0'
              )}
              onClick={controller.handleClearClick}
            />
            <img
              src="/icon-close.svg"
              className={clsx(
                'absolute pointer-events-auto !h-[18px]',
                !searchValue && 'opacity-0'
              )}
              onClick={controller.handleClearClick}
            />
          </div>

          <input
            type="text"
            value={controller.inputValue}
            onChange={controller.handleChange}
            onKeyDown={controller.handleKeyDown}
            maxLength="16"
            name="quickSearch"
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            className="w-full h-full py-[4px] pt-[6px] px-[12px] bg-[#3a44aa] outline-none border-none rounded-[2px] text-white"
            ref={controller.inputRef}
          />
        </div>
      </div>
      {controller.isLoading && <SiteLoader />}
    </div>
  );
};

export default GlobalSearch;
